import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Society_Update,
  Society_Delete,
  Society_ReadAll,
  Society_Create,
  Society_ReadById,
  Society_ReadByUserId,
  Society_OnboardingComplete,
  Society_OnboardingReadAllPaginated,
  Society_ExternalReadById,
  Society_ReadAllPaginated,
} from 'src/app/GlobalVariable';
import {
  SocietyCreateRequestDTO,
  SocietyUpdateRequestDTO,
  SocietyDeleteRequestDTO,
  SocietyReadByIdRequestDTO,
  SocietyDTO,
  societyList,
  SocietyReadByUserIdRequestDTO,
  SocietyReadByUserIdResponseDTO,
  SocietyOnboardingCompleteRequestDTO,
} from './society.interface';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root',
})
export class SocietyService {


  http = inject(HttpClient);

  Society_Create(data: SocietyCreateRequestDTO): Observable<SocietyDTO> {
    return this.http.post<SocietyDTO>(Society_Create, data);
  }

  Society_Update(data: SocietyUpdateRequestDTO): Observable<SocietyDTO> {
    return this.http.post<SocietyDTO>(Society_Update, data);
  }

  Society_Delete(data: SocietyDeleteRequestDTO): Observable<any> {
    return this.http.post<any>(Society_Delete, data);
  }

  Society_ReadAll(): Observable<societyList> {
    return this.http.get<societyList>(Society_ReadAll);
  }

  Society_ReadById(data: SocietyReadByIdRequestDTO): Observable<SocietyDTO> {
    return this.http.post<SocietyDTO>(Society_ReadById, data);
  }

  Society_ExternalReadById(
    data: SocietyReadByIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<SocietyDTO> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set('X-Api-Key', xApiKey)
        .set('X-Api-Timestamp', xApiTimestamp || '')
        .set('X-Api-Nonce', xApiNonce || '')
        .set('X-Api-Signature', xApiSignature);
    }
    return this.http.post<SocietyDTO>(Society_ExternalReadById, data, { headers });
  }

  getSocietyByUserId(data: SocietyReadByUserIdRequestDTO): Observable<SocietyReadByUserIdResponseDTO> {
    return this.http.post<SocietyReadByUserIdResponseDTO>(Society_ReadByUserId, data);
  }

  Society_OnboardingComplete(data: SocietyOnboardingCompleteRequestDTO): Observable<void> {
    return this.http.post<void>(Society_OnboardingComplete, data);
  }

  Society_OnboardingReadAllPaginated(data: PaginatedDTO): Observable<societyList> {
    return this.http.post<societyList>(Society_OnboardingReadAllPaginated, data);
  }

  Society_ReadAllPaginated( data: PaginatedDTO): Observable<societyList> {
  return this.http.post<societyList>(Society_ReadAllPaginated,data);
}
  
}
